(() => {
  "use strict";
  // Count previews use the same serialized URL as an actual filter click.
  const selector = '[data-nicecnc-submodel-count], [data-nicecnc-preview-count]';
  const previewParams = [
    'filter.p.m.custom.vehicle_make',
    'filter.p.m.custom.vehicle_model',
    'filter.p.m.custom.by_year'
  ];
  const states = new WeakMap();
  let queued = false;
  function write(node, value, source) {
    const text = value === null ? '…' : String(value);
    if (node.firstChild?.nodeType === Node.TEXT_NODE && node.childNodes.length === 1) {
      if (node.firstChild.nodeValue !== text) node.firstChild.nodeValue = text;
    }
    node.dataset.nicecncCountSource = source;
  }
  function countFrom(scope) {
    const raw = scope.querySelector('[data-nicecnc-result-count]')?.getAttribute('data-nicecnc-result-count');
    return raw !== null && raw !== undefined && /^\d+$/.test(raw) ? Number(raw) : null;
  }
  function visible(node) {
    return node.getClientRects().length > 0 && !node.closest('[hidden]');
  }
  function ensurePreviewCountNodes(root) {
    for (const param of previewParams) {
      for (const input of root.querySelectorAll(`input[name="${param}"]`)) {
        const wrapper = input.closest('.checkbox-container, .block-swatch');
        if (!wrapper || !visible(wrapper)) continue;
        const label = input.labels?.[0];
        if (!label || label.querySelector('[data-nicecnc-preview-count]')) continue;
        const match = (label.textContent || '').match(/^(.*\()([0-9]+)(\)[\u200e\u200f\u061c\s]*)$/);
        if (!match) continue;
        const node = document.createElement('span');
        node.dataset.nicecncPreviewCount = '';
        node.textContent = match[2];
        label.replaceChildren(document.createTextNode(match[1]), node, document.createTextNode(match[3]));
      }
    }
  }
  function hasChecked(root, param) {
    return !!root.querySelector(`input[name="${param}"]:checked`);
  }
  function needsRemotePreview(input, root) {
    // Shopify's native count already equals the real click result when the click
    // would not clear any active descendants. Avoid dozens of redundant section
    // requests at the Make -> Model stage on broad Collections.
    if (input.name === 'filter.p.m.custom.vehicle_make') {
      return hasChecked(root, 'filter.p.m.custom.vehicle_model') ||
        hasChecked(root, 'filter.p.m.custom.vehicle_submodel') ||
        hasChecked(root, 'filter.p.m.custom.by_year');
    }
    if (input.name === 'filter.p.m.custom.vehicle_model') {
      return hasChecked(root, 'filter.p.m.custom.vehicle_submodel') ||
        hasChecked(root, 'filter.p.m.custom.by_year');
    }
    if (input.name === 'filter.p.m.custom.by_year') return false;
    return true;
  }
  function scanRoot(root) {
    const facet = root.closest('product-facet');
    const form = root.querySelector('form');
    if (!facet || !form || facet.dataset.nicecncLoading || !window.nicecncFitmentUrl) return;
    // Search has different counting semantics. This patch targets collections.
    const current = countFrom(facet);
    if (current === null) return;
    let state = states.get(root);
    if (!state || state.form !== form) {
      state?.controller.abort();
      state = { form, controller: new AbortController(), requests: new Map(), queue: [], running: 0 };
      states.set(root, state);
    }
    const sid = facet.getAttribute('section-id');
    if (!sid) return;
    const snapshot = location.href;
    ensurePreviewCountNodes(root);
    const valid = () => root.isConnected && states.get(root) === state &&
      root.querySelector('form') === form && !facet.dataset.nicecncLoading && location.href === snapshot;
    for (const node of root.querySelectorAll(selector)) {
      const wrapper = node.closest('.checkbox-container, .block-swatch');
      const input = wrapper?.querySelector('input');
      if (!input) continue;
      if (!visible(node)) continue;
      if(input.closest('[data-nicecnc-missing-facet="1"]'))continue;
      if (!needsRemotePreview(input, root)) {
        node.dataset.nicecncCountSource = 'native-click-equivalent';
        continue;
      }
      const url = window.nicecncFitmentUrl(root, input);
      if (!url) continue;
      url.searchParams.set('section_id', sid);
      url.searchParams.sort();
      const key = url.toString();
      let job = state.requests.get(key);
      if (!job) {
        job = { key, nodes: new Set(), count: null, done: false, full: input.hasAttribute('data-nicecnc-virtual-parent') || input.name === 'filter.p.m.custom.vehicle_submodel' };
        state.requests.set(key, job);
        state.queue.push(job);
      }
      job.nodes.add(node);
      if(job.done&&job.count!==null)input.disabled=job.count===0&&!input.checked;
      write(node, job.done ? (job.count === null ? '—' : job.count) : null, job.done ? (job.count === null ? 'unavailable' : 'complete-list') : 'pending');
    }
    function pump() {
      if (!valid()) return;
      while (state.running < 3 && state.queue.length) {
        const job = state.queue.shift();
        state.running++;
        const controller = new AbortController();
        const abort = () => controller.abort();
        state.controller.signal.addEventListener('abort', abort, { once: true });
        const timer = setTimeout(abort, 8000);
        const fresh=new URL(job.key);fresh.searchParams.set('_nc_refresh',String(Date.now()));
        ((job.full && window.NICECNCFullSubmodels && (!window.NICECNCFullSubmodels.needsFullRender || window.NICECNCFullSubmodels.needsFullRender(facet)))
          ? window.NICECNCFullSubmodels.count(fresh.href, root)
          : fetch(fresh.href, { credentials: 'same-origin', cache:'no-store', signal: controller.signal })
              .then(response => response.ok ? response.text() : null)
              .then(html => html ? countFrom(new DOMParser().parseFromString(html, 'text/html')) : null))
          .then(count => { job.count = count; })
          .catch(() => {})
          .finally(() => {
            clearTimeout(timer);
            state.controller.signal.removeEventListener('abort', abort);
            state.running--;
            job.done = true;
            if (valid()) {
              for (const node of job.nodes) if (node.isConnected) {write(node,job.count===null?'—':job.count,job.count===null?'unavailable':'complete-list');const input=node.closest('.checkbox-container')?.querySelector('input');if(input&&job.count!==null)input.disabled=job.count===0&&!input.checked;}
              pump();
            }
          });
      }
    }
    pump();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('facet-filters').forEach(scanRoot);
    }));
  }
  function init() {
    const facet = document.querySelector('product-facet');
    if (!facet) return;
    new MutationObserver(schedule).observe(facet, { subtree: true, childList: true });
    document.addEventListener('nicecnc:facets-rendered', schedule);
    window.addEventListener('pageshow',e=>{if(e.persisted)facet.dispatchEvent(new CustomEvent('facet:criteria-changed',{bubbles:true,detail:{url:location.href}}));});
    // Count newly revealed Other children and collapsed groups after opening.
    facet.addEventListener('click', () => setTimeout(schedule, 300));
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
